import { get } from 'lodash';
export const roomQuantity = (accommodations: Array<Accommodation>) =>
  accommodations
    .filter((accommodation) => accommodation.quantity > 1)
    .map<number>((accommodation) => accommodation.quantity);
export const getNbAccommodations = (accommodationsSet: AccommodationsSet): number => {
  return get(accommodationsSet, 'accommodations', []).reduce(
    (acc, accommodation) => acc + get(accommodation, 'quantity', 0),
    0,
  );
};
